import { render, staticRenderFns } from "./CandidateListStructured.vue?vue&type=template&id=73431d0d&"
import script from "./CandidateListStructured.vue?vue&type=script&lang=js&"
export * from "./CandidateListStructured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports